import { render, staticRenderFns } from "./KeywordsAddPage.vue?vue&type=template&id=733ddc80&"
import script from "./KeywordsAddPage.vue?vue&type=script&lang=js&"
export * from "./KeywordsAddPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports